//import firebase from "@firebase/app";
// import util from "@/util";
import $models from '@/models'
import clonedeep from 'lodash.clonedeep';
import util from '@/util'
import moment from "@/moment-gp";

let timerObjSec = null;
let timerObjMin = null;

export default {

  session_start_system_timer({ commit, dispatch, state, rootGetters }) {
    clearInterval(timerObjSec);
    clearInterval(timerObjMin);

    /* Set time, so we don't have to wait for first intervall */
    commit('SET_SYSTEM_TIME_SECOND');
    commit('SET_SYSTEM_TIME_MINUTE'); // WARUM RAUS?

    timerObjSec = setInterval(() => {
      commit('SET_SYSTEM_TIME_SECOND');
      dispatch('session_update_active_session_id')
      dispatch('session_update_timer_status')
    }, 1000);

    /* FIX: A setInteravall timer won't start at the beginnen of a full
            minute, thats why we wait for a few seconds.
       PROBLEM: It will probably out of sync at some point */
    let secondsUntilFullMinute = 60 - Math.floor(Date.now() / 1000 % 60);
    setTimeout(() => {
      commit('SET_SYSTEM_TIME_MINUTE');
      timerObjMin = setInterval(() => {
        commit('SET_SYSTEM_TIME_MINUTE');
      }, 1000 * 60);
    }, secondsUntilFullMinute * 1000 )
  },

  session_stop_system_timer({ commit }) {
    clearInterval(timerObjSec);
    clearInterval(timerObjMin);
  },

  session_timer_start(context, { taskId, commitmentId, memberId, goalId, duration })  {

    let timer_data = context.getters.session_user_timer

    // check if a timer is already running
    if (timer_data && timer_data.taskId && !timer_data.paused && timer_data.startedAt && timer_data.startedAt + timer_data.durationRemaining > context.getters.session_system_time) {
      if (timer_data.taskId !== taskId) {
        context.dispatch('session_update_duration_remaining_in_task')
      }
    }
    context.dispatch('session_start_system_timer')
    $models.taskRecordedSession.with({
      goalId: goalId
    })
    .add({
      taskId: taskId,
      commitmentId: commitmentId,
      duration: duration
    })
    .then(pushId => {
      let startedAt = context.getters.session_system_time // TODO: Convert to moment
      $models.userTimer
      .update( $models.user.defaultUserId, {
        taskId: taskId,
        goalId: goalId,
        pushId: pushId,
        startedAt: startedAt,
        durationRemaining: duration,
        paused: false
      })

      $models.userStatus.update( $models.user.defaultUserId, {
        taskId: taskId,
        taskRecordingStartedAt: startedAt, // TODO Convert to firebase timestamp
        taskDuration: duration,
        memberId: memberId,
        goalId: goalId
      })
    })
  },

  session_timer_pause(context, { taskId, commitmentId, goalId, duration })  {
    context.dispatch('session_update_duration_remaining_in_task')
    context.commit('SET_TIMER_STATUS', 'paused')
    //context.commit('PAUSE_ACTIVE_SESSION');

    let timer_data = context.getters.session_user_timer
    if (timer_data && timer_data.$ready) {
      $models.taskRecordedSession.with({
        goalId: timer_data.goalId
      })
      .update(timer_data.pushId, {
        duration: context.getters.session_system_time - timer_data.startedAt
      })
      $models.userTimer
      .update( $models.user.defaultUserId,{
        durationRemaining: Math.max(0, timer_data.durationRemaining - (context.getters.session_system_time - timer_data.startedAt) ),
        paused: true
      })

      $models.userStatus.update( $models.user.defaultUserId, {
        taskId: null,
        taskRecordingStartedAt: null,
        taskDuration: null,
        goalId: null,
        memberId: null,
      })
    }
  },

  /*session_timer_continue(context, { sessionId, goalId })  {
    $models.userTimer
    .update( $models.user.defaultUserId, {
      taskId: ''
    })
  },*/
  session_timer_end(context)  {
    context.dispatch('session_update_duration_remaining_in_task')
  },

  session_timer_stop(context)  {
    if (context.getters.session_timer_status() !== 'paused') {
      context.dispatch('session_update_duration_remaining_in_task')
    }

    let timer_data = context.getters.session_user_timer
    if ( timer_data &&
         timer_data.$ready &&
         timer_data.goalId &&
         context.getters.session_timer_status() !== 'paused') {

      $models.taskRecordedSession.with({
        goalId: timer_data.goalId
      })
      .update(timer_data.pushId, {
        duration: context.getters.session_system_time - timer_data.startedAt
      })
    }

    $models.userTimer.update( $models.user.defaultUserId, {
      taskId: null,
      goalId: null,
      pushId: null,
      startedAt: null,
      durationRemaining: null,
      paused: null
    })

    $models.userStatus.update( $models.user.defaultUserId, {
      taskId: null,
      taskRecordingStartedAt: null,
      taskDuration: null,
      goalId: null,
      memberId: null,
    })
  },

  session_timer_reset(context, { durationRemaining })  {
    let timer_data = context.getters.session_user_timer
    let duration = durationRemaining
    if (context.getters.session_time_remaining > durationRemaining) {
      duration = context.getters.session_time_remaining
    }

    let durationUntilNow = clonedeep(context.getters.session_time_elapsed)
    $models.userTimer
    .update( $models.user.defaultUserId, {
      startedAt: context.getters.session_system_time,
      durationRemaining: duration
    })
    $models.taskRecordedSession
      .with({ goalId:  timer_data.goalId })
      .update(timer_data.pushId, {
        duration: durationUntilNow + duration
      })
  },

  session_update_duration_remaining_in_task(context) {
    // update remainign time in task
    let timer_data = context.getters.session_user_timer
    let task_data = context.getters.session_active_task
    if (timer_data && timer_data.$ready && task_data && task_data.$ready && task_data.durationRemaining) {
      // update recorded session
      $models.taskRecordedSession
        .with({ goalId:  timer_data.goalId })
        .update(timer_data.pushId, {
          duration: context.getters.session_system_time - timer_data.startedAt
        })
      $models.taskMeta
        .with({ goalId: timer_data.goalId, uid: $models.user.defaultUserId })
        .update( timer_data.taskId, { durationRemaining: Math.max(0,  task_data.durationRemaining -  (context.getters.session_system_time - timer_data.startedAt)) })
    }
  },

  session_restart_timer(context) {
    console.log('session_restart_timer()')
    let timer_data = context.getters.session_user_timer
    if (timer_data.$ready && timer_data.taskId && context.getters.session_timer_status(timer_data.taskId) === 'running' && timerObjSec === null) {
      context.dispatch('session_start_system_timer')
    }
  },

  /*session_update_active_session_index({ commit, dispatch, state, rootGetters }) {
    let sessions = rootGetters['optimizer/optimizer_sessions_filtered']
      if (sessions) {
        let firstId = rootGetters['optimizer/optimizer_active_session_id']
        let nrSessions = sessions.length
        for (let i = firstId; i < nrSessions; i++) {
          if (state.time_updated_every_sec >= sessions[i].from && state.time_updated_every_sec <= sessions[i].until ) {
            if (!state.activeSessionIndex || i !== state.activeSessionIndex) {
              commit('SET_ACTIVE_SESSIONS_INDEX', i)
            }
            return
          }
        }
      }
    },*/

    session_update_active_session_id({ commit, dispatch, state, rootGetters }) {
      let view_date = moment(state.time_updated_every_sec * 1000).format('YYMMDD') // TODO: take day change into account
      if (rootGetters['dayplanner/dayplanner_sessions']) {
        let sessions = rootGetters['dayplanner/dayplanner_sessions']
          .itemsAsArray()
          // .filter(session => session.dateString === getters.view_current_date_as_yymmdd)
          .filter(session => session.dateString >= view_date)
          .sort(util.sorter.by_from);

        let activeSession = null
        let nextSession = null
        let firstId = 0 //rootGetters['optimizer/optimizer_active_session_id']
        let nrSessions = sessions.length

        for (let i = firstId; i < nrSessions; i++) {
          if ( !sessions[i] || !sessions[i].from || !sessions[i].to ) {
            continue
          }
          if ( sessions && sessions[i] && sessions[i].from && sessions[i].to ) {
            if ( state.time_updated_every_sec >= sessions[i].from.unix()
              && state.time_updated_every_sec <= sessions[i].to.unix() ) {
              if (sessions[i].$id !== state.activeSessionId) {
                activeSession = sessions[i]
              }
              if (i < nrSessions - 1 ) {
                nextSession = sessions[i + 1]
              }
              break;
            }
          }
          if (!activeSession) {
            if (state.time_updated_every_sec < sessions[i].from.unix()  ) {
              if (i < nrSessions) {
                nextSession = sessions[i]
              }
              break;
            }
          }
        }

        if (activeSession ) {
          if (activeSession.$id !== state.activeSessionId) {
            // commit('SET_ACTIVE_SESSION', clonedeep(activeSession))
            // commit('SET_ACTIVE_SESSION', activeSession)
            commit('SET_ACTIVE_SESSION', null)
          }

          commit('SET_ACTIVE_SESSION_TIME_UNTIL_END', activeSession.to.unix() - state.time_updated_every_sec )
        } else {
          commit('SET_ACTIVE_SESSION', null)
        }
        if (nextSession) {
          if (nextSession.$id !== state.nextSessionId) {
            // commit('SET_NEXT_SESSION', clonedeep(nextSession))
            // commit('SET_NEXT_SESSION', nextSession)
            commit('SET_NEXT_SESSION', null)

          }
          commit('SET_ACTIVE_SESSION_TIME_UNTIL_START',  nextSession.from.unix() - state.time_updated_every_sec)
        } else {
          commit('SET_NEXT_SESSION', null)
        }
      }
    },

    session_update_timer_status({ commit, dispatch, state, rootGetters }) {
      let timer_data = rootGetters['session/session_user_timer']
      let timer_status = null
      if (timer_data && timer_data.$ready ) {
        if (timer_data.taskId && !timer_data.paused ) {
          let currentTime = state.time_updated_every_sec;
          if (timer_data.startedAt + timer_data.durationRemaining > currentTime ) {
            timer_status = 'running'
          } else if (timer_data.startedAt + timer_data.durationRemaining <= currentTime ) {
            timer_status = 'ended'
          } else {  // check if this is the active task, otherwise return stopped
            timer_status =  'stopped'
          }
        }
      } else {
        timer_status = 'stopped'
      }
      if (timer_status && state.timer_status !== timer_status) {
        commit('SET_TIMER_STATUS', timer_status)
      }
    }

  // session_set_filterByGoalId(context, { goalId }) {
  //   console.log('session_set_filterByGoalId', goalId)
  //   context.commit('SET_FILTER_BY_GOALID', goalId)
  // },
  // session_set_filterByCommitmentId(context, { commitmentId })  {
  //   console.log('session_set_filterByCommitmentId', commitmentId)
  //   context.commit('SET_FILTER_BY_COMMITMENTID', commitmentId)
  // },
  // session_set_filterByTscId(context, { tscId })  {
  //   console.log('session_set_filterByTscId', tscId)
  //   context.commit('SET_FILTER_BY_TSCID', tscId)
  // },
}
